import script from "./SeoLandingView.vue?vue&type=script&setup=true&lang=js"
export * from "./SeoLandingView.vue?vue&type=script&setup=true&lang=js"

import "./SeoLandingView.vue?vue&type=style&index=0&id=13ef2d8a&lang=scss"

const __exports__ = script;

export default __exports__